import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GenericTypeService {
  API_SERVER: string = environment.baseApiUrl;
  reloadTable$ = new BehaviorSubject(false);

  constructor(private httpClient: HttpClient) {}

  findAll(params?): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    return this.httpClient
      .get(this.API_SERVER + 'generic-types', { params: Params });
  }

  findOne(id): Observable<any> {
    return this.httpClient
      .get(this.API_SERVER + `generic-types/${id}`);
  }

  create(data): Observable<any> {
    return this.httpClient
      .post(this.API_SERVER + 'generic-types', data);
  }

  update(id, data): Observable<any> {
    return this.httpClient
      .put(this.API_SERVER + `generic-types/${id}`, data);
  }

  remove(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `generic-types/${id}`);
  }

  restore(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `generic-types/restore/${id}`);
  }
}
